import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';

import useTranslation from '@/hooks/useTranslation';
import getMetaData from '@/helpers/getMetaData';

const selector = ({ order }) => ({
  shoppingCartType: order.currentOrder?.shoppingCartType
});

const SEO = () => {
  const { pathname } = useLocation();
  const { shoppingCartType } = useSelector(selector);
  const { t } = useTranslation();
  const [data, setData] = useState<{title:string}>({} as {title:string});
  const { title } = data;
  useEffect(() => {
    setData(getMetaData(pathname, shoppingCartType));
  }, [pathname, shoppingCartType]);

  return (
    <Helmet
      defaultTitle={t('TITLE_DEFAULT')}
      title={t(title)}
      titleTemplate={`%s | ${t('TITLE_DEFAULT')}`}
    ></Helmet>
  );
};

export default SEO;
